import { mapState } from 'vuex';
import { mapActions } from 'vuex';

import { TIPO_GRUPO } from '../../util/constantes';

export default {
  data() {
    return {
      infiniteLoadingId: 0,
      loadingGrupos: false,
      loadingSubGrupos: false,
      loadingTipos: false,

      tipoContaPesquisa: [],

      filtroTipoConta: 'TODOS',
      filtroTipoGrupo: 'TODOS',
      filtroSubGrupoConta: 'TODOS',

      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    }
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "PLANOS_CONTA"
          })[0];
      },
      isSubGrupoHabilitado(state) { return state.usuarioLogado.imobiliaria.parametros.tipoESubgrupoConta }
    }),
    ...mapState('planosContaStore', {
      planosConta(state) { return state.listaPlanosConta },
      planoContaPesquisa(state) { return state.planoContaPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      planoConta(state) { return state.planoContaSelecionado },

      gruposDisponiveis(state) { return state.gruposDisponiveis },
      subGruposDisponiveis(state) { return state.subGruposDisponiveis },
      tiposDisponiveis(state) { return state.listaTipos },

      tiposDisponiveisPesquisa(state) { return state.listaTiposPesquisa },
      gruposDisponiveisPesquisa(state) { return state.gruposDisponiveisPesquisa },
      subGruposDisponiveisPesquisa(state) { return state.subGruposDisponiveisPesquisa } 
    }),
    tiposGrupo() {
      return TIPO_GRUPO;
    },
    exibirBotaoNovoPlanoConta() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarPlanoConta() {
      return(
        (this.planoConta.id === 0 && this.permissoes.cadastro)
        || (this.planoConta.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverPlanoConta() {
      return this.planoConta.id != 0 && this.permissoes.remocao;
    },

    validacao() {
      return {
        nome: [{ required: true }],
        tipoConta: [{ required: true }],
      }
    },
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('planosContaStore', [
      'listarPlanosConta',
      'limparPlanosContaListadas',
      'limparPlanoContaPesquisa',
      'recuperarPlanoConta',
      'novoPlanoConta',
      'gravarPlanoConta',
      'removerPlanoConta',
      'listarGrupos',
      'listarSubGrupos',
      'listarTipo',
      'limparTipoContaSelecionado',
      'limparGrupoPlanoContaSelecionado',
      'limparSubGrupoPlanoContaSelecionado',
      'limparSubGrupoPlanoContaPesquisa',
      'limparGrupoPlanoContaPesquisa',
      'limparTipoContaPesquisa',
      'listarTipoPesquisa',
      'listarGruposPesquisa',
      'listarSubGruposPesquisa'
    ]),
    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },
    pesquisarHandler() {
      this.planoContaPesquisa.pagina = 0;
      this.limparPlanosContaListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      let payload = {
        pagina: this.planoContaPesquisa.pagina,
        grupoPlanoConta: { tipo: this.planoContaPesquisa.tipo = undefined ? undefined : this.planoContaPesquisa.grupoPlanoConta.tipo },
        nome: this.planoContaPesquisa.nome
      }
      
      if(this.planoContaPesquisa.subGrupoPlanoConta) {
        payload.grupoPlanoConta = this.planoContaPesquisa.subGrupoPlanoConta
      } else if(this.planoContaPesquisa.grupoPlanoConta.id) {
        payload.grupoPlanoConta = this.planoContaPesquisa.grupoPlanoConta
      } else if(this.planoContaPesquisa.tipoConta) {
        payload.grupoPlanoConta = this.planoContaPesquisa.tipoConta
      }
      if(payload.grupoPlanoConta.paiGrupoPai) { payload.grupoPlanoConta.paiGrupoPai = undefined }
      if(this.planoContaPesquisa.pagina === 0) { this.showLoading(); }

      this.listarPlanosConta(payload).then((resultado) => {
        if(this.planoContaPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.planoContaPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.planoContaPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.planoContaPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    limparPesquisa() {
      this.limparPlanoContaPesquisa();
    },
    recuperarHandler(planoConta) {
      this.recuperar(planoConta);
    },
    recuperar(planoConta) {
      const payload = {
        id: planoConta.id
      }
      this.showLoading();
      this.recuperarPlanoConta(payload).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      })
    },
    gravar() {
      let grupo = undefined
      if(this.planoConta.subGrupoPlanoConta) {
        grupo = this.planoConta.subGrupoPlanoConta
      } else if(this.planoConta.grupoPlanoConta) {
        grupo = this.planoConta.grupoPlanoConta
      } else if(this.planoConta.tipoConta) {
        grupo = this.planoConta.tipoConta
      }

      const payload = {
        ...this.planoConta,
        grupoPlanoConta: grupo,
        tipoConta: undefined,
        subGrupoPlanoConta: undefined,
      }
      if(payload.grupoPlanoConta.paiGrupoPai) { payload.grupoPlanoConta.paiGrupoPai = undefined }
      this.showLoading();
      this.gravarPlanoConta(payload).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.filtroTipoConta = 'TODOS'
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerHandler() {
      this.$confirm('Deseja realmente remover este Plano de Contas?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.remover();
      });
    },
    remover() {
      if(this.planoConta.subGrupoPlanoConta) {
        this.planoConta.grupoPlanoConta = this.planoConta.subGrupoPlanoConta
      } else if(this.planoConta.grupoPlanoConta) {
        this.planoConta.grupoPlanoConta = this.planoConta.grupoPlanoConta
      } else if(this.planoConta.tipoConta) {
        this.planoConta.grupoPlanoConta = this.planoConta.tipoConta
      }

      this.planoConta.tipoConta = undefined
      this.planoConta.subGrupoPlanoConta = undefined

      this.showLoading();
      this.removerPlanoConta(this.planoConta).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    // UTIL
    filtrarTipoSelect(queryString) {
      let tipoSelecionado = undefined
      if(this.filtroTipoConta !== 'TODOS') {
        tipoSelecionado = this.filtroTipoConta;
      }

      let payload = { nome: queryString, tipo: tipoSelecionado }
      this.loadingTipos = true;
      this.listarTipo(payload)
      .then(() => {
        this.loadingTipos = false;
      });
    },

    filtrarGruposSelect(queryString) {
      let payload = { nome: queryString, grupoPai: { id: this.planoConta.tipoConta ? this.planoConta.tipoConta.id : undefined }}
      this.loadingGrupos = true;
      this.listarGrupos(payload)
      .then(() => {
        this.loadingGrupos = false;  
      });
    },

    filtrarSubGruposSelect(queryString) {  
      let payload = { nome: queryString, grupoPai: { id: this.planoConta.grupoPlanoConta ? this.planoConta.grupoPlanoConta.id : undefined } }
      this.loadingSubGrupos = true
      this.listarSubGrupos(payload)
      .then(() =>{
        this.loadingSubGrupos = false;
      });
    },

    filtrarTipoSelectPesquisa(queryString) {
      let payload = { nome: queryString }
      this.loadingTipos = true;
      this.listarTipoPesquisa(payload)
      .then((resultado) => {
        this.tipoContaPesquisa = resultado.lista;
        this.loadingTipos = false;
      });
    },

    filtrarGruposSelectPesquisa(queryString) {
      let payload = { nome: queryString, grupoPai: { id: this.planoContaPesquisa.tipoConta ? this.planoContaPesquisa.tipoConta.id : undefined } }
      this.loadingGrupos = true
      this.listarGruposPesquisa(payload)
      .then(() => {
        this.loadingGrupos = false;
      });
    },

    filtrarSubGruposSelectPesquisa(queryString) {  
      let payload = { nome: queryString, grupoPai: { id: this.planoContaPesquisa.grupoPlanoConta ? this.planoContaPesquisa.grupoPlanoConta.id : undefined } }
      this.loadingSubGrupos = true
      this.listarSubGruposPesquisa(payload)
      .then(() =>{
        this.loadingSubGrupos = false;
      });
    },

    formatarDetalhesDaConta(conta) {
      if(conta.grupoPlanoConta.grupoPai.id == 0 &&
      conta.grupoPlanoConta.grupoPai.paiGrupoPai.id == 0) {
        return `> Tipo de Conta: ${conta.grupoPlanoConta.nome}`
      } else if(conta.grupoPlanoConta.grupoPai.id != 0 &&
      conta.grupoPlanoConta.grupoPai.paiGrupoPai.id == 0) {
        return `> Tipo de Conta: ${conta.grupoPlanoConta.grupoPai.nome } > Grupo de Contas: ${conta.grupoPlanoConta.nome}`
      } else {
        return `> Tipo de Conta: ${conta.grupoPlanoConta.grupoPai.paiGrupoPai.nome} > Grupo de Contas: ${conta.grupoPlanoConta.grupoPai.nome} > Subgrupo de Contas: ${conta.grupoPlanoConta.nome}`
      }
    }
  }
}